import { Reveal } from "./Reveal";
import { Btn, Overline } from "./Btn";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "@/data/company";

export const CtaBand = ({ title = "Un projet d'enseigne ou de signalétique ?", subtitle }) => (
  <section className="relative overflow-hidden border-y border-white/10 bg-ink-800 noise-overlay" data-testid="cta-band">
    <div className="pointer-events-none absolute -left-20 top-1/2 h-64 w-64 -translate-y-1/2 rounded-full bg-signature/20 blur-3xl" />
    <div className="pointer-events-none absolute -right-20 top-1/2 h-64 w-64 -translate-y-1/2 rounded-full bg-electric/15 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
      <Reveal className="flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl">
          <Overline>Parlons de votre projet</Overline>
          <h2 className="mt-4 text-3xl sm:text-4xl font-bold text-white">{title}</h2>
          <p className="mt-3 text-base sm:text-lg text-slate-300">
            {subtitle || "De la conception à la pose, un seul interlocuteur en France et en Suisse. Obtenez une étude et un devis sans engagement."}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <Btn to="/contact/" size="lg" data-testid="cta-band-devis">
            Demander un devis <ArrowRight className="h-4 w-4" />
          </Btn>
          <Btn href={COMPANY.phoneHref} variant="secondary" size="lg" data-testid="cta-band-phone">
            <Phone className="h-4 w-4" /> {COMPANY.phone}
          </Btn>
        </div>
      </Reveal>
    </div>
  </section>
);
